import React, { useState, useEffect } from "react";
// import AttendeesData from "./AttendeesData";
// import Pagination from "./Pagination";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import faker from "faker";
import SmartDataTable from "react-smart-data-table";
import Loader from "../loader";
import { EventDetailAttendees } from "../../../actions/auth";
import { MY_PROFILE } from "../../../actions/types";
const generateData = (attendeeslist = 0, numTransactResults = 0) => {
  let total = numTransactResults || 0;
  if (typeof numTransactResults === "string") {
    total = parseInt(numTransactResults, 10);
  }
  const AttendeesTable = [];
  for (let i = 0; i < total; i += 1) {
    //   var a = i;

    AttendeesTable.push({
      Name:
        attendeeslist[i].firstname + "--" + attendeeslist[i].profile_image[0],
      email: attendeeslist[i].email,
      location: faker.address.city(),
    });
  }
  return AttendeesTable;
};

const Attendees = ({ id }) => {
  const dispatch = useDispatch();
  const [numTransactResults, setNumTransactResults] = useState(0);
  const [AttendeesTable, setAttendeesTable] = useState(null);
  const [totalCount, setTotalCount] = useState(0);

  useEffect(async () => {
    await dispatch(EventDetailAttendees(id, 1)).then((res) => {

      res &&
        res.data &&
        setAttendeesTable(
          generateData(res.data.attended_users, res.data.attended_users.length)
        );
      res && res.data && setNumTransactResults(res.data.attended_users.length);
      res && res.data && setTotalCount(res.data.totalCount);
    }, []);
  }, []);

  const headers = {
    Name: {
      text: "User Name",
      invisible: false,
      sortable: true,
      filterable: true,
      transform: (value, index, row) => {
        return (
          <>
            <ul className="p-0">
              <li className="d-flex align-items-center">
                <Link to="#">
                  <img
                    alt=""
                    src={`${MY_PROFILE}/${value.split("--")[1]}`}
                    className="profilleeData"
                    onError={(e) => {
                      e.target.onerror = null; // Prevent infinite loop in case `noImage.png` also fails
                      e.target.src = "img/noImage.png"; // Fallback image if loading fails
                    }}
                  />
                </Link>
                <div className="ml-2">
                  <h5 className="clientName">
                    <Link to="#" className="clientName">
                      {" "}
                      {value.split("--", 1)}
                    </Link>
                  </h5>
                </div>
              </li>
            </ul>
            {/* <p>
              <input type="checkbox" className="mr-2" />
              <Link
                className="profileLinks"
                to={`/events-details/${row.eventid}`}
              >
                {value.split('--',1)}
              </Link>
            </p> */}
          </>
        );
      },
    },
    email: {
      text: "Email",
      invisible: false,
      sortable: true,
      filterable: true,
      transform: (value, index, row) => {
        return (
          <>
            <p>{value ? value : "-"}</p>
          </>
        );
      },
    },
    location: {
      text: "Location",
      invisible: false,
      sortable: true,
      filterable: true,
      transform: (value, index, row) => {
        return (
          <>
            <p>{value ? value : "-"}</p>
          </>
        );
      },
    },
  };
  return (
    <div className="attendeesWrap">
      {/* <div className="container-fluid">
        <div className="row pt-2">
          <div className="col-lg-6 col-md-6 col-sm-12 col-12">
            <div className="Search-Field">
              <label className="form-label fields-label">Search</label>
              <input
                type="search"
                className="form-control input-fields"
                id="searchbyevent"
                placeholder="By Event Name"
              />
              <i className="fas fa-search search-icon"></i>
            </div>
          </div>
        </div>
      </div> */}

      <div className="eventsDataWrap">
        <div className="container">
          <div className=" EventsData">
            <SmartDataTable
              data={AttendeesTable}
              dataKey=""
              headers={headers}
              name="test-table"
              className="ui compact selectable table eventsDataTable"
              withLinks
              withHeader
              loader={<Loader />}
              parseImg={{
                style: {
                  border: "1px solid #ddd",
                  borderRadius: "2px",
                  padding: "3px",
                  width: "60px",
                },
              }}
              dynamic
              emptyTable={
                <div style={{ textAlign: "center" }}>No attendees found</div>
              }
            />
          </div>
        </div>
      </div>

      {/* <AttendeesData /> */}
      {/* <Pagination /> */}
    </div>
  );
};

export default Attendees;
